export default "__VITE_ASSET__72bUPiso__"